export const GET_MAPPEDSTATIONSBYASSEMBLY_REQUEST =
  "GET_MAPPEDSTATIONSBYASSEMBLY_REQUEST";
export const GET_MAPPEDSTATIONSBYASSEMBLY_SUCCESS =
  "GET_MAPPEDSTATIONSBYASSEMBLY_SUCCESS";
export const GET_MAPPEDSTATIONSBYASSEMBLY_FAILURE =
  "GET_MAPPEDSTATIONSBYASSEMBLY_FAILURE";
